import styled, { css } from 'styled-components';

import { Label } from '@r1-frontend/ui-react/components/label';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import Button from '~/src/features/_layout/Header/desktop/components/MainMenuItem/components/Button';
import Description from '~/src/features/_layout/Header/desktop/components/MainMenuItem/components/Description';
import Title from '~/src/features/_layout/Header/desktop/components/MainMenuItem/components/Title';

import { SButton } from '~/src/features/_layout/Header/desktop/components/MainMenuItem/components/Button/styled';

export interface IImageProps {
    imageSrc?: string,
    imageAlt?: string,
    top?: number,
    left?: number,
    isHover?: boolean,
}

export const AnimationImg = styled.img`
    position: absolute;
    transform: scale(.8);
    opacity: 0;
    transition: all .3s ease;
    object-fit: cover;
    top: -30px;
    left: -10px;
    width: 205px;
    height: auto;
`;

export const PromoItemWrapper = styled.div<{ isPromoMemu?: boolean, isCurrent: boolean }>`
    flex-direction: row;
    flex-wrap: nowrap;
    padding: 8px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgSurface};
    position: relative;
    max-width: 457px;
    width: auto;
    pointer-events: ${p => p.isCurrent ? 'none' : 'auto'};

    ${({ isPromoMemu }) => isPromoMemu
        ? css`
            align-self: stretch;
        `
        : css`
            align-self: baseline;
            justify-self: end;
        `
    };

    &:hover {
        background-color: ${COLORS.BgLight};

        ${SButton} {
            color: ${COLORS.Error};

            &:after {
                background-color: ${COLORS.Error};
            }
        }

        ${AnimationImg} {
            transform: scale(1);
            opacity: 1;
        }
    }
`;

export const ImageBlock = styled.div<{ isPromoMemu?: boolean }>`
    flex: 1 0 182px;
    height: ${({ isPromoMemu }) => isPromoMemu ? '100%' : '159px'};
    border-radius: ${BorderRadius.InnerBlockRadius};
    overflow: hidden;
    position: relative;
`;

export const ItemImage = styled.img`
    width: 100%;
    height: 100%;
    object-pisition: center;
    object-fit: cover;
`;

export const ContentBlock = styled.div<{ isPromoMemu?: boolean }>`
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100%;
    padding: ${({ isPromoMemu }) => isPromoMemu ? '16px 24px 20px 20px' : '10px 16px 12px 24px'};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        padding: 0 24px 0 16px;
    }
`;

export const ContentLinkWrapper = styled.a`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
`;

export const LabelsBlock = styled.div`
    flex-direction: row;
    flex-wrap: nowrap;
    margin-bottom: 4px;
`;

export const SLabel = styled(Label)`
    &:not(:last-child) {
        margin-right: 4px;
    }
`;

export const ItemTitle = styled(Title)`
    margin-bottom: 4px;
    white-space: pre-wrap;
`;

export const ItemDescription = styled(Description)`
    flex: 1 1 auto;
    margin-bottom: 4px;
`;

export const ItemBtn = styled(Button)`
    margin: auto 0;
`;
